import { put, takeLatest, all, call } from 'redux-saga/effects';
import { setAction, getMembersAction, getDivisionMembersAction } from '../actions/teamMembersPage';
import actionTypes from '../../../redux/actions/action-types';
import { snackBar } from 'highed';
import {
  getTeamUsersWithTeamid,
  delTeamUserUsingTeamidAndUserid,
  delTeamUserBatchUsingTeamid,
  postTeamGroupUserUsingTeamidAndGroupidAndUserid,
  postDivisionUserUsingDivisionidAndUserid,
  getDivisionTeamAllWithDivisionidAndTeamid,
} from '../../../api/cloudApiGenerated';

export function* getMembers(params) {
  let { team, pageSize, page } = params.data;

  try {
    let members = yield call(getTeamUsersWithTeamid, team.id, page, pageSize);
    members.forEach((member) => {
      member.defaultCheck = false;
    });
    yield put(
      setAction({
        members,
        dataReturned: true,
      })
    );
  } catch (e) {
    yield put(
      setAction({
        errorMessage: e.response.message.join(' '),
      })
    );
  }
}

export function* getDivisionMembers(params) {
  let { team, pageSize, page, members, division } = params.data;

  try {
    let divisionMembers = yield call(getDivisionTeamAllWithDivisionidAndTeamid, division, team.id, page, pageSize);
    members.forEach((m) => (m.defaultCheck = false));
    divisionMembers.forEach((dMember) => {
      let member = members.find((x) => x.id === dMember.user_id);
      if (member) {
        member.defaultCheck = dMember.inDivision === 1;
      }
    });

    yield put(
      setAction({
        members,
      })
    );
  } catch (e) {
    console.log(e);
    yield put(
      setAction({
        errorMessage: e.response.message.join(' '),
      })
    );
  }
}

export function* updateUsersGroup(params) {
  let { team, row, page, pageSize } = params.data;

  try {
    yield call(postTeamGroupUserUsingTeamidAndGroupidAndUserid, team.id, row.group_id, row.id);
    yield put(getMembersAction({ team, page, pageSize }));
    snackBar('Member group updated');
  } catch (e) {
    yield put(
      setAction({
        error: 'setting access group of member: ' + error.message.join(' '),
      })
    );
  }
}

export function* updateDivisionMembers(params) {
  let { team, page, pageSize, members, activeDivision, checkboxValues } = params.data,
    promises = [];

  members.forEach((member, i) => {
    let data = {
      inDivision: checkboxValues[i] || false,
    };
    promises.push(call(postDivisionUserUsingDivisionidAndUserid, parseInt(activeDivision), member.id, data));
  });

  try {
    let data = yield all(promises);
    snackBar('Division members updated');
    yield put(getDivisionMembersAction({ team, division: activeDivision, page, pageSize, members }));
  } catch (e) {
    console.log(e);
  }
}

export function* deleteTeamUsers(params) {
  let { team, users, page, pageSize } = params.data;

  let ids = [];
  const owner_user = team.owner_user;

  users.forEach((user) => {
    if (user && user.id !== owner_user) {
      ids.push(user.id);
      //promises.push(call(delTeamUserUsingTeamidAndUserid,team.id,userId));
    }
  });

  if (ids.length === 0) return;

  try {
    let data = yield call(delTeamUserBatchUsingTeamid, team.id, {
      users: ids.join(','),
    });
    yield put(getMembersAction({ team, page, pageSize }));
    snackBar('Member deleted');
  } catch (error) {
    yield put(
      setAction({
        error: error.toString(),
      })
    );
  }
}

/** Watch functions */
export function* watchGetMembers() {
  yield takeLatest(actionTypes.teamMembersPage.getMembers, getMembers);
}
export function* watchGetDivisionMembers() {
  yield takeLatest(actionTypes.teamMembersPage.getDivisionMembers, getDivisionMembers);
}
export function* watchUpdateUsersGroup() {
  yield takeLatest(actionTypes.teamMembersPage.updateUsersGroup, updateUsersGroup);
}
export function* watchUpdateDivisionMembers() {
  yield takeLatest(actionTypes.teamMembersPage.updateDivisionMembers, updateDivisionMembers);
}
export function* watchDeleteTeamUsers() {
  yield takeLatest(actionTypes.teamMembersPage.deleteTeamUsers, deleteTeamUsers);
}

// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([
    watchGetMembers(),
    watchGetDivisionMembers(),
    watchUpdateUsersGroup(),
    watchUpdateDivisionMembers(),
    watchDeleteTeamUsers(),
  ]);
}
